<template>
  <section class="webshop-list view-list">
    <div class="container">
      <div
        v-if="hasTopContent"
        class="row"
      >
        <div class="col-12">
          <slot name="top" />
        </div>
      </div>
      <div class="row webshop-list__title view-list__title mb-5">
        <div class="col-12 d-flex flex-wrap">
          <div
            :class="'bg-category-' + currentFilter.id"
            class="icon text-white text-center p-2 mr-4"
          >
            <i :class="brancheIcon(currentFilter.id)" />
          </div>
          <div class="text">
            <small class="d-block mb-2 font-patrick-hand">Categorie</small>
            <h2>{{ currentFilter.name }}</h2>
          </div>
        </div>
      </div>
      <div class="row webshop-list__items view-list__items flex-wrap">
        <div
          v-if="surroundings.length !== 0"
          class="col-12 d-flex flex-wrap"
        >
          <div
            v-for="(item, index) in surroundings[pageIndex]"
            :key="index"
            class="surrounding mb-4 px-2 w-100 w-sm-50 w-md-25 w-lg-20"
            @click="$router.push({ name: 'webshop.store', params: { city: kebab(item.address.city), slug: kebab(item.name) + '-' + item.webshop.id } })"
          >
            <div class="surrounding-inner">
              <div
                :style="{ backgroundImage: 'url(' + getImage(item.banners) + ')' }"
                class="surrounding-inner__top mb-3 position-relative"
              >
                <div
                  v-if="item.branche.id !== undefined"
                  :class="'bg-category-' + item.branche.id"
                  class="icon position-absolute text-white text-center p-2"
                >
                  <i :class="brancheIcon(item.branche.id)" />
                </div>
              </div>
              <div class="surrounding-inner__bottom">
                <h4 class="mb-1">{{ item.name }}</h4>
                <span>{{ item.address.city.charAt(0).toUpperCase() + item.address.city.slice(1) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          :class="'col-12'"
        >
          <p class="p-5 text-center">
            <span>In gemeente {{ $store.state.surrounding.name }} zijn er nog geen actieve webshops.</span>
          </p>
        </div>
        <div class="col-12 pagination justify-content-end d-flex flex-wrap">
          <span class="align-self-center font-weight-bold font-montserrat text-uppercase">Pagina</span>
          <el-pagination
            :page-size="pageSize"
            :total="total"
            layout="pager, slot"
            @current-change="setPage"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Branche from '@/mixins/Branche'
import Utilities from '@/mixins/Utilities'

export default {
  name: 'ec-webshop-list',
  mixins: [
    Branche,
    Utilities
  ],
  props: {
    currentFilter: {
      type: Object,
      default () {
        return {}
      }
    },
    surroundings: {
      type: Array,
      default () {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      pageIndex: 0,
      pagerCount: 1,
      pageSize: 15
    }
  },
  computed: {
    hasTopContent () {
      return !!this.$slots['top']
    }
  },
  methods: {
    getImage (banners) {
      if (banners.length) {
        return banners[0].url
      }
      return ''
    },
    setPage (value) {
      this.$parent.isLoading = true
      this.pageIndex = value - 1

      setTimeout(() => {
        this.$parent.isLoading = false
      }, 200)
    }
  }
}
</script>
